module.exports = __webpack_public_path__ + "img/IMG_5528.4d38b78b.jpg";